import { getHostName } from "../utils";

export async function fetchOperators() {
  const data = await fetch(`${getHostName()}/api/operators/?format=json`);
  return await data.json();
}
